import React from 'react';
import PropTypes from 'prop-types';
import Tree from './Tree';
import { getFlattenedTree } from './helpers/getFlattenedTree';
import { updateNodeInTree } from './helpers/nodeHelpers';
import './_TreeContainer.scss';

export default class TreeContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      flattenedTree: getFlattenedTree(props.nodes)
    };
    this.handleChange = this.handleChange.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.nodes !== this.props.nodes) {
      const nodes = getFlattenedTree(nextProps.nodes);
      this.setState({
        flattenedTree: nodes
      });
    }
  }

  handleChange(node) {
    const updatedNodes = updateNodeInTree(this.props.nodes, node);
    this.props.onChange(updatedNodes);
  }

  render() {
    const { flattenedTree } = this.state;
    const rowIndex = flattenedTree.findIndex(node => node.id === this.props.scrollToId);
    return (
      <div className="TreeContainer">
        <Tree
          {...this.props}
          nodes={flattenedTree}
          onChange={this.handleChange}
          scrollToIndex={rowIndex}
          maxHeight={this.props.height}
        />
      </div>
    );
  }
}

TreeContainer.propTypes = {
  nodes: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func,
  onSelect: PropTypes.func,
  nodeMarginLeft: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  scrollToId: PropTypes.number,
  selectionTreeProps: PropTypes.object
};

TreeContainer.defaultProps = {
  nodeMarginLeft: 30
};
